import "./App.css";
import NavBar from "./Component/Navbar";
import Routers from "./Component/Router";
function App() {
  return (
    <div className="App">
      <NavBar />
      <Routers />
    </div>
  );
}

export default App;
